export default __webpack_public_path__ + "static/media/go_back_icon.7ab5de73.svg";